import React, { useRef } from 'react'
import ReactPlayer from 'react-player'

import { HtmlVideoContainerStyled } from './styles'

import { HtmlVideoProps } from './types'

const HtmlVideo: React.FC<HtmlVideoProps> = ({ videoSrc, posterSrc }) => {
  const videoParentRef = useRef(null)

  return (
    <HtmlVideoContainerStyled ref={videoParentRef}>
      <ReactPlayer playing muted={true} loop={true} playsinline={true} url={videoSrc} width="100%" height="100%" />
    </HtmlVideoContainerStyled>
  )
}

export default HtmlVideo
